import React from 'react';
import { observer } from 'mobx-react';
import CardStore from '../../stores/card';
import ExcelTableColgroup from './Colgroup';
import ExcelTableTBody from './TableTBody';
import classnames from 'classnames';
import jQuery from 'jquery';
import { doGlobalSpin } from '../../util';
import * as DetailUtil from '../../util/cubeUtil';

export interface ExcelLayoutProps {
    Card: CardStore;
    className?: string;
}

@observer
export default class ExcelLayout extends React.Component<ExcelLayoutProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            contentH: 500
        }
    }
    componentDidMount() {
        let h = jQuery(".mode-card-resource").height();
        if (h == null) {
            h = jQuery(".wea-new-top-req-content").height();
        }
        this.setState({ contentH: h });
        //必填校验 暂时先预执行一次校验逻辑  防止后续校验出错 -------by ljc
        // this.props.Card.cubeForm.validate();
        /***显示布局的是很绑定document点击事件 */
        const {params,quickEditStore} = this.props.Card;
        if(params.type == '0'){
            document.addEventListener('mousedown', quickEditStore.handleClickOutSide, true);
        }
    }

    componentDidUpdate (){
        const { Card ,} = this.props;
        if(Card.showGlobalSpin.isShow == 'hide'){
            Card.showGlobalSpin.isShow = 'none';
        }
    }

    componentWillUnmount() {
        const {quickEditStore} = this.props.Card;
        document.removeEventListener("mousedown", quickEditStore.handleClickOutSide);
    }

    render() {
        const { Card, className } = this.props;
        const { cardMarginParams: { padding },showGlobalSpin } = Card;
        const cardtype = Card.base.type;  //当只有显示模板的的时候不需要添加最小高度，页面出现空白
        /**
      * 这里做了大量的计算，主要处理表单边距的问题；
      * 回复评论的两种情况，底部显示和右侧显示
      * */
        const showReply = Card.base.showReply;
        const replyposition = Card.base.replyposition == 1;  //1  是底部
        const classNames = classnames(className, 'excelMainTable');
        const style = {
            margin: "0 auto",
            width: Card.modeExcel.tableStyle['width'],
            backgroundImage:Card.modeExcel.backgroundImg ? 'URL(' + `${Card.modeExcel.backgroundImg}` + ')':'none'
        };
        const fromStyle = Card.waterImg ? {
            backgroundAttachment: 'scroll', backgroundRepeat: 'repeat', width: "100%",
            backgroundImage: 'URL(' + `${Card.waterImg}` + ')'
        } : {};
        if(showGlobalSpin.isShow !== 'none'){
            doGlobalSpin(showGlobalSpin);
        }
        return (
            <div className="cube-card-wrap"
                style={{
                    minHeight: cardtype == "0" && showReply && replyposition ? "auto" :
                        showReply && !replyposition ? this.state.contentH - padding.top - padding.bottom : this.state.contentH,
                    padding: cardtype == "0" && showReply && !replyposition ? "" : `${cardtype == "4"?"0px 0px":padding.top + "px " + padding.right + "px " + padding.bottom + "px " + padding.left + "px"}`
                }}>
                <div className="cube-card-form"
                    style={{
                        ...fromStyle,
                        minHeight: cardtype == "0" && showReply && replyposition ? "auto" :
                            this.state.contentH - padding.top - padding.bottom,
                    }} >
                    <div
                        className="cube-card-excelMainTable-wrapper"
                        style={{
                            overflowX: 'auto',
                            minHeight: cardtype == "0" && showReply && replyposition ? "auto" :
                                this.state.contentH - padding.top - padding.bottom,
                            paddingBottom: 20
                        }}
                        onScroll={this.doScrollYEvent.bind(this)}
                        >
                        <table className={classNames} style={style}  >
                            <ExcelTableColgroup ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableColgroup@d4f8mf`} excel={Card.modeExcel} />
                            <ExcelTableTBody ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableTBody@upfebd`} excel={Card.modeExcel} card={Card} form={Card.cubeForm} actions={Card.Actions} />
                        </table>
                    </div>
                </div>
            </div>
        )
    }

    doScrollYEvent() {
        DetailUtil.fixedDetailHead();   //明细表头固定
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/index.tsx